<script>
    export default {
        data: function () {
            return {
                active: false
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// sv_cms/static/assets/vue/components/svToggleContent.vue